// src/components/ProtectedRoute.jsx
// Wraps private pages. Redirects to /login if user is not authenticated.
// Shows nothing while the auth state is being initialised (avoids flash).
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthContext } from '../context/AuthContext';

/**
 * ProtectedRoute — use this for pages that require login.
 * If the token is still being loaded from localStorage, renders null (no flash).
 * Once loaded, if not authenticated, redirects to /login with the original path stored
 * so we can send them back after login.
 */
export const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuthContext();
  const location = useLocation();

  if (loading) return null; // or a spinner — prevents flash of redirect

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

/**
 * PublicRoute — use this for pages like /login and /register.
 * If the user is ALREADY authenticated, redirects them to /dashboard
 * so they never see a "logged in account on the login page" issue.
 */
export const PublicRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuthContext();

  if (loading) return null;

  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return children;
};
